import template from './sellFragments.html';
import controller from './sellFragments.controller';

export default {
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    form: '=',
    portfolio: '=',
    uncheckable: '@',
    asCard: '@',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/app/common/ui/sellFragments/sellFragments.component.js